import { me } from "@api/courses/stats/users/me/path";

export const users = {
  me,
};
